export const STATUS = 'status';
export const NAME = 'name';
export const BUDGET = 'budget';
export const BID_STRATEGY_TYPE = 'bid_strategy_type';

export const DEFAULT_COLUMN_WIDTH = 100;
export const CAMPAIGN_COLUMN_WIDTH = 200;
export const CAMPAIGN_COLUMN_MAX_WIDTH = 300;
export const STATUS_COLUMN_MAX_WIDTH = 20;
export const BUDGET_COLUMN_MAX_WIDTH = 150;
export const NON_COMPARISON_METRICS_COLUMNS = [
    'status',
    'name',
    'bid_strategy_type',
    'budget',
    'type',
    'projected_cost',
    'projected_revenue',
    'projected_conversions',
    'projected_clicks',
];
export const NON_COMPARISON_METRICS = [
    'account_id',
    'account_name',
    'campaign_id',
    'account_currency',
    'objective',
    'cost_per_action_type',
    'date_start',
    'date_stop',
    'platform',
    'name',
    'status',
    'bid_strategy_type',
    'type',
    'level',
    'tags',
    'is_cbo',
];
export const DEFAULT_SORT = [{ id: 'cost', desc: true }];
export const DEFAULT_SORT_COMPARISON = [{ id: 'main_cost', desc: true }];
export const METRICS_PREFIX = {
    main: 'main_',
    comparison: 'comparison_',
    diff: 'diff_',
    percentage_diff: 'percentage_diff_',
};
